import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import { Form, Table } from "react-bootstrap";
import { fetchAllDataAPI, filterByParams } from "../../utils/api";
import Skeleton from "react-loading-skeleton";
import { numberFormat } from "../../utils/numberFormat";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import ReportNavBar from "../../components/ReportNavBar";
import withAuth from "../../utils/withAuth";
import { CiExport } from "react-icons/ci";
import CsvDownloader from 'react-csv-downloader';

const AgentPerformance = () => {
    const [report, setReport] = useState([]);
    const [filteredReport, setFilteredReport] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });
    const [valueRange, setValueRange] = useState("");

    useEffect(() => {
        getAgentPerformanceReport();
    }, []);

    const getAgentPerformanceReport = async () => {
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("super-admin-get-agent-performance-report-last-two-months");
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (error) {
            console.error("Error fetching report:", error);
        }
        setIsLoading(false);
    };


    const handleFilterByDate = async (event, picker) => {
        setIsLoading(true);
        const selectedRange = {
            startDate: picker.startDate.format("YYYY-MM-DD"),
            endDate: picker.endDate.format("YYYY-MM-DD")
        };
        setDateRange(selectedRange);
        try {
            const res = await filterByParams("super-admin-get-agent-performance-by-daterange", selectedRange);
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };
    const handleReset = async () => {
        setSearchTerm("");
        const defaultRange = {
            startDate: moment().subtract(2, 'months').startOf('month').toDate(),
            endDate: moment().subtract(1, 'months').endOf('month').toDate()
        };
        setDateRange(defaultRange);
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("super-admin-get-agent-performance-report-last-two-months");
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (error) {
            console.error("Reset fetch error:", error);
        }
        setIsLoading(false);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredData = report.filter(item =>
            item.agent_name.toLowerCase().includes(value) ||
            item.center_name.toLowerCase().includes(value) ||
            item.member_name.toLowerCase().includes(value)
        );
        setFilteredReport(filteredData);
    };

    const columns = [
        { id: 's_no', displayName: 'Serial No' },
        { id: 'agent_name', displayName: 'Agent Name' },
        { id: 'agent_emp_id', displayName: 'Agent Emp ID' },
        { id: 'center_name', displayName: 'Center Name' },
        { id: 'member_name', displayName: 'TL Name' },
        { id: 'month_1_value', displayName: filteredReport[0]?.month_1_label || "Month 1" },
        { id: 'month_2_value', displayName: filteredReport[0]?.month_2_label || "Month 2" },
        { id: 'growth_percentage', displayName: 'Growth (%)' }
    ];
    const exportReport = filteredReport.map((item, index) => ({
        s_no: index + 1,
        agent_name: item.agent_name,
        agent_emp_id: item.agent_emp_id || '',
        center_name: item.center_name,
        member_name: item.member_name,
        month_1_value: item.month_1_value || 0,
        month_2_value: item.month_2_value || 0,
        growth_percentage: Number(item.growth_percentage).toFixed(2) + "%"
    }));

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR: AGENT PERFORMANCE</title>
            </Helmet>
            <ContentWrapper>
                <ReportNavBar />
                <div className="card p-2" style={{ marginBottom: "50px" }}>
                    <div className="heading d-flex justify-content-between mb-2">
                        <h5 className="mb-0 text-uppercase mt-2">
                            Agent Performance Report from {moment(dateRange.startDate).format("MMMM YYYY")} to {moment(dateRange.endDate).format("MMMM YYYY")}
                        </h5>
                        <div className="mt-1 d-flex">
                            <Form.Control
                                type="text"
                                placeholder="Search by Center OR Agent Name OR TL"
                                value={searchTerm}
                                onChange={handleSearch}
                                className="mb-3"
                            />
                            <Form.Select
                                className="ms-2 mb-3"
                                value={valueRange}
                                style={{width:"50%"}}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setValueRange(val);

                                    if (!val) {
                                        setFilteredReport(report);
                                        return;
                                    }

                                    const [min, max] = val.split("-").map(Number);
                                    const filtered = report.filter(item => {
                                        const total = (item.month_2_value || 0);
                                        return total >= min && total <= max;
                                    });
                                    setFilteredReport(filtered);
                                }}
                            >
                                <option value="">All</option>
                                <option value="0-100000">₹0 - ₹1L</option>
                                <option value="100000-200000">₹1L - ₹2L</option>
                                <option value="200001-400000">₹2L - ₹4L</option>
                                <option value="400001-700000">₹4L - ₹7L</option>
                                <option value="700001-10000000">₹7L+</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex">
                            <CsvDownloader
                                filename={`Agent_Performance_${moment().format("YYYY_MM_DD")}`}
                                extension=".csv"
                                datas={exportReport}
                                columns={columns}
                                className="btnorderfilter"
                                style={{ marginTop: "7px" }}
                            >
                                <CiExport className="svgexport" />
                                <span
                                    style={{ color: "#fff", border: "none" }}
                                    className="btn btn-info btn-sm btnfilter"
                                >
                                    Export
                                </span>
                            </CsvDownloader>
                            <span onClick={handleReset} className="btnreset">Reset</span>
                            <div className="btnpicker">
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: dateRange.startDate,
                                        endDate: dateRange.endDate,
                                    }}
                                    onApply={handleFilterByDate}
                                >
                                    <button className="btn btn-md btndaterange">Select Date Range</button>
                                </DateRangePicker>
                            </div>
                        </div>
                    </div>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Agent Name</th>
                                    <th>Center Name</th>
                                    <th>TL Name</th>
                                    <th>{filteredReport[0]?.month_1_label || "Month 1"}</th>
                                    <th>{filteredReport[0]?.month_2_label || "Month 2"}</th>
                                    <th>Growth (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    [...Array(5)].map((_, index) => (
                                        <tr key={index}>
                                            {Array.from({ length: 7 }).map((_, i) => (
                                                <td key={i}>
                                                    <Skeleton animation="wave" variant="text" />
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredReport.length > 0 ? (
                                    filteredReport.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.agent_name} ({item.agent_emp_id})</td>
                                            <td>{item.center_name}</td>
                                            <td>{item.member_name}</td>
                                            <td>{numberFormat(item.month_1_value)}</td>
                                            <td>{numberFormat(item.month_2_value)}</td>
                                            <td style={{ fontWeight: "600", color: item.growth_percentage >= 0 ? "green" : "red" }}>
                                                {Number(item.growth_percentage).toFixed(2)}%
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan="4" className="text-end fw-bold">Grand Total</th>
                                    <th className="fw-bold">{numberFormat(filteredReport.reduce((sum, item) => sum + (item.month_1_value || 0), 0))}</th>
                                    <th className="fw-bold">{numberFormat(filteredReport.reduce((sum, item) => sum + (item.month_2_value || 0), 0))}</th>
                                    <th style={{
                                        fontWeight: "bold",
                                        color: (
                                            (() => {
                                                const total1 = filteredReport.reduce((sum, item) => sum + (item.month_1_value || 0), 0);
                                                const total2 = filteredReport.reduce((sum, item) => sum + (item.month_2_value || 0), 0);
                                                return total2 - total1 >= 0 ? "green" : "red";
                                            })()
                                        )
                                    }}>
                                        {
                                            (() => {
                                                const total1 = filteredReport.reduce((sum, item) => sum + (item.month_1_value || 0), 0);
                                                const total2 = filteredReport.reduce((sum, item) => sum + (item.month_2_value || 0), 0);
                                                const growth = total1 > 0 ? ((total2 - total1) / total1) * 100 : (total2 > 0 ? 100 : 0);
                                                return `${growth.toFixed(2)}%`;
                                            })()
                                        }
                                    </th>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default withAuth(AgentPerformance);
